module.exports = __webpack_public_path__ + "img/pic-coin@3x.741f0635.png";